import { connect, useDispatch } from "react-redux";
// import {
//   getNotification,
//   getStudentHelp,
// } from "../../../../../action/masters/appActionCreator";
import { useEffect, useState } from "react";
import { Draggable } from "react-drag-reorder";
import {
  getStudentHelps,
  updateStudentHelpPriority,
} from "../../../../action/masters/studentHelpActionCreator";
import {
  changePositionOnDrag,
  prioratiseItems,
} from "../../../../common-functions/commonFunctions";
import { cloneDeep, baseURL } from "../../../../constants/commonConstants";
import { getAlertData } from "../../../../helper/sweet-alert";
import {
  IUpdateStudentHelpPriority,
  IStudentHelpData,
} from "../../../../models/master/studentHelp";
import { setStudentHelps } from "../../../../store/slices/master/studentHelpSlice";
import LoaderSpinner from "../../../../common-components/loader";

const PriorityStudentHelp = (props: IUpdateStudentHelpPriority) => {
  const {
    updateStudentHelpPriority,
    getStudentHelps,
    studentHelps,
    configUserRole,
  } = props;
  const [filteredItems, setfilteredItems] = useState<any[]>([]);
  const [loader, setLoader] = useState(true);
  const [alertType, setAlertType] = useState<any>("success");
  const [alertTitle, setAlertTitle] = useState<string>("Default");
  const dispatch = useDispatch();

  const saveChangedPos = async (currentPos: any, newPos: any) => {
    if (currentPos != newPos) {
      setLoader(true);
      let _items = changePositionOnDrag(filteredItems, currentPos, newPos);
      await setfilteredItems(_items);
      updateStudentHelpPriority(_items, setAlert);
    }
  };

  const ChangeVisibleOrNot = async (id: number, _displayOrNot: boolean) => {
    /////method 1
    setLoader(true);
    let index = filteredItems.findIndex((x) => x.id == id);
    let _afterFilteration = [];
    let _filteredItems = [...filteredItems];
    let selectedItem = _filteredItems.splice(index, 1);
    selectedItem[0].displayOrNot = _displayOrNot;

    selectedItem[0].priority = null;
    _afterFilteration = [
      ...prioratiseItems(_filteredItems.filter((x) => x.displayOrNot == true)),
      ...selectedItem,
      ..._filteredItems.filter((x) => x.displayOrNot == false),
    ];
    let _items = prioratiseItems(_afterFilteration);
    
    setfilteredItems([..._items]);
    updateStudentHelpPriority(_items, setAlert);

    /////method 2
    // let _filteredItems = [...filteredItems]
    // let item = _filteredItems[index];
    // item.displayOrNot = __displayOrNot;
    // _filteredItems[index] = item;
    // updateAppPriority(item, setAlert);
    // setFilteredItems(_filteredItems);
  };

  const setAlert = (type: string) => {
    let alertData = getAlertData(type);
    if (alertData) {
      setLoader(false);
      setAlertType(alertData.type);
      setAlertTitle(alertData.title);
    }
  };

  const getAllStudentHelps = async (configUserRoleId: number) => {
    setLoader(true)
    try{
      await getStudentHelps(configUserRoleId);
    }
    finally{
      setLoader(false)
    }
  };

  useEffect(() => {
    getAllStudentHelps(configUserRole);
    return () => {
      dispatch(setStudentHelps([]));
    };
  }, [configUserRole]);

  useEffect(() => {
    studentHelps && setfilteredItems(cloneDeep(studentHelps));
  }, [studentHelps]);

  return (
    <>
      <div className="admincontent">
        <div className="title">
          <h2>Student Help</h2>
        </div>
        <ul className="d-flex gap-3 flex-wrap mt-28">
          {loader ? (
            <LoaderSpinner/>
          ) : filteredItems && filteredItems?.length > 0 ? (
            <>
              {" "}
              <Draggable
                onPosChange={async (currentPos, newPos) => {
                  await saveChangedPos(currentPos, newPos);
                }}
              >
                {filteredItems
                  .filter((item: IStudentHelpData) => item.displayOrNot)
                  .map((studentHelp: IStudentHelpData, index: number) => (
                    <li className="admin-card">
                      <div className="top">
                        <span className="handle">
                          <img src="/assets/images/drag.svg" />
                        </span>
                        <span className="counter">{studentHelp.priority}</span>
                        <div className="form-checkbox">
                          <input
                            type="checkbox"
                            checked={studentHelp.displayOrNot}
                            id={studentHelp.priority + "studentHelp"}
                            onChange={() => {
                              
                              ChangeVisibleOrNot(
                                studentHelp.id ?? 0,
                                !studentHelp.displayOrNot
                              );
                            }}
                          />
                          <label
                            htmlFor={studentHelp.priority + "studentHelp"}
                          ></label>
                        </div>
                      </div>
                      <div className="btm">
                        <div className="img">
                          <img
                            src={
                              studentHelp.icon ? baseURL + studentHelp.icon : ""
                            }
                          />
                        </div>
                        <h2>{studentHelp.title}</h2>
                        <p>{studentHelp.description}</p>
                      </div>
                    </li>
                  ))}
              </Draggable>
              {filteredItems
                .filter((item: IStudentHelpData) => !item.displayOrNot)
                .map((studentHelp: IStudentHelpData, index: number) => (
                  <li className="admin-card">
                    <div className="top">
                      <span className="handle">
                        <img src="/assets/images/drag.svg" />
                      </span>
                      <span className="counter">{}</span>
                      <div className="form-checkbox">
                        <input
                          type="checkbox"
                          checked={studentHelp.displayOrNot}
                          id={studentHelp.priority + "studentHelp"}
                          onChange={() => {
                            
                            ChangeVisibleOrNot(
                              studentHelp.id ?? 0,
                              !studentHelp.displayOrNot
                            );
                          }}
                        />
                        <label
                          htmlFor={studentHelp.priority + "studentHelp"}
                        ></label>
                      </div>
                    </div>
                    <div className="btm">
                      <div className="img">
                        <img
                          src={studentHelp.icon ? baseURL + studentHelp.icon : ""}
                        />
                      </div>
                      <h2>{studentHelp.title}</h2>
                      <p>{studentHelp.description}</p>
                    </div>
                  </li>
                ))}
            </>
          ) : (
            <p>No Records Found</p>
          )}{" "}
        </ul>
      </div>
    </>
  );
};

const mapDispatchToProps = {
  getStudentHelps: (configUserRole: number) => getStudentHelps(configUserRole),
  updateStudentHelpPriority: (data: any, callBack: Function) =>
    updateStudentHelpPriority(data, callBack),
};

function mapStateToProps(state: any) {
  return {
    studentHelps: state.studentHelp.studentHelps,
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PriorityStudentHelp);
